import { CommonModule } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatSelectModule } from '@angular/material/select';
import { RouterLink } from '@angular/router';
import { NgbDropdownModule, NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { environment } from '../../../environments/environment';

@Component({
  selector: 'app-navigation',
  imports: [
    MatInputModule,
    MatSelectModule,
    MatFormFieldModule,
    TranslateModule,
    CommonModule,
    FormsModule,
    NgbDropdownModule,
    NgbModule,
    RouterLink,
  ],
  templateUrl: './navigation.component.html',
  styleUrl: './navigation.component.scss',
})
export class NavigationComponent implements OnInit {
  private readonly translate = inject(TranslateService);

  public features = environment.features;
  public selectedLanguage = '';
  public languages: Record<string, string> = {};

  ngOnInit(): void {
    this.loadLanguages();
  }

  private loadLanguages(): void {
    this.translate.use('de-de');
    this.selectedLanguage = localStorage.getItem('lang') === 'de-de' ? 'German' : 'English';
    if (this.selectedLanguage === 'German') {
      this.translate.use('de-de');
      this.selectedLanguage = 'Deutsch';
    } else {
      this.translate.use('en');
      this.selectedLanguage = 'English';
    }
    this.translate.get('General.UiLanguages').subscribe((res: Record<string, string>) => {
      this.languages = res;
    });
  }

  switchLanguage(key: string): void {
    const languageMap = {
      german: { code: 'de-de', label: 'General.UiLanguages.German' },
      deutsch: { code: 'de-de', label: 'General.UiLanguages.German' },
      english: { code: 'en', label: 'General.UiLanguages.English' },
      englisch: { code: 'en', label: 'General.UiLanguages.English' },
    } as const;

    const langKey = key.toLowerCase() as keyof typeof languageMap;
    if (languageMap[langKey]) {
      const { code, label } = languageMap[langKey];
      this.translate.use(code);
      localStorage.setItem('lang', code);
      this.selectedLanguage = this.translate.instant(label);

      this.translate.get('General.UiLanguages').subscribe((res: Record<string, string>) => {
        this.languages = res as Record<string, string>;
      });
    }
  }
}
